import React, { useState } from 'react';
import styles from './searchBox.module.css';

export default ({ kd }: { kd: string }) => {
  const [keyword, setKeyword] = useState<string>(kd);

  return (
    <>
      <div className={styles.searchBox}>
        <div className={styles.searchBoxWrap}>
          <div className={styles.searchBoxInput}>
            <input
              className={styles.searchBoxInputBox}
              placeholder="请输入关键字"
              value={keyword}
              onChange={e => {
                setKeyword(e.target.value);
              }}
            />
            {keyword.length > 0 && (
              <div
                className={styles.searchBoxClose}
                onClick={() => {
                  setKeyword('');
                }}
              ></div>
            )}
          </div>
          {keyword.length === 0 ? (
            <>
              <button className={styles.searchBoxBtn1}>搜文档</button>
              <button className={styles.searchBoxBtn2}>搜图书</button>
            </>
          ) : (
            <>
              <a href={`https://tm.docin.com/touch_new/search.do?rkey=${encodeURI(keyword)}`} className={styles.searchBoxBtn1}>
                搜文档
              </a>
              {/* <a href={`http://localhost:3000/bookstore_touch/searchResult?keyword=${keyword}`} className={styles.searchBoxBtn2}>
                搜图书
              </a> */}
              <a href={`https://mobile.docin.com/bookstore_touch/searchResult?keyword=${keyword}`} className={styles.searchBoxBtn2}>
                搜图书
              </a>
            </>
          )}
        </div>
      </div>
    </>
  );
};
//
